<div class="clr-row">
  <div class="clr-col">
    <table class="table">
      <thead>
        <tr>
          <th>Policy</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let policy of getPolicyFormGroups()" [class.selected]="isPolicySelected(policy)">
          <td>
            {{ policy.get('name')?.value }}
            <span *ngIf="policy.get('required')?.value" class="label">Required</span>
          </td>
          <td class="center">
            <clr-toggle-wrapper>
                <input
                    type="checkbox"
                    clrToggle
                    name="enabled"
                    [formControl]="policy.get('enabled')"
                />
                <label class="ml-1">{{ policy.get('enabled')?.value ? 'Enabled' : 'Disabled' }}</label>
            </clr-toggle-wrapper>
          </td>
          <td>
            <button
              class="btn btn-sm btn-link"
              [disabled]="readonly || !policy.get('enabled')?.value"
              (click)="editPolicy(policy)">
              <clr-icon shape="note"></clr-icon> View/Edit
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Policy Editor Modal -->
<vdr-modal *ngIf="editingPolicy$ | async as policy">
  <div class="modal-header">
    <h3>{{ policy.name }}</h3>
  </div>
  <div class="modal-body">
    <vdr-rich-text-editor
      [formControl]="editingContentControl"
      [label]="'Edit Policy Content'"
    ></vdr-rich-text-editor>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeEditor()">
      Close
    </button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="resetToDefault(policy.type)">
      Reset to Default Template
    </button>
  </div>
</vdr-modal>
